import React, { useState, useEffect } from "react";
import { Global } from "../helpers/Global";
import { Peticion } from "../helpers/Peticion";



export const Curriculum = () => {

  const [certifitaces, setCertificates] = useState([]);
  const [ knowledges, setKnowledges] = useState([]);
  const [ skillsCode, setSkillsCode ] = useState([]);
  const [ skillsDesing, setSkillsDesing ] = useState([]);
  const [ experiences, setExperiences ] = useState([]);
  const [ trainings, setTrainings ] = useState([]);
  
    const getCertificate = async () => {
      let { datos } = await Peticion(Global.url + "curriculum/certificates/", "GET");
  
      if (datos) {
        setCertificates(datos.data);
      }
    };

    const getKnowledges = async () => {
      let { datos } = await Peticion(Global.url + "curriculum/knowlenges/", "GET");
  
      if (datos) {
        setKnowledges(datos.data);
      }
    };

     const getExperiences = async () => {
      let { datos } = await Peticion(Global.url + "curriculum/experiences/", "GET");
  
      if (datos) {
        setExperiences(datos.data);
      }
    };

    const getSkillsCode = async () => {
      let { datos } = await Peticion(Global.url + "curriculum/skillscodes/", "GET");
  
      if (datos) {
        setSkillsCode(datos.data);
      }
    };

    const getSkillsDesing = async () => {
      let { datos } = await Peticion(Global.url + "curriculum/skillsdesings/", "GET");
  
      if (datos) {
        setSkillsDesing(datos.data);
      }
    };

    const getTrainings = async () => {
      let { datos } = await Peticion(Global.url + "curriculum/trainings/", "GET");
  
      if (datos) {
        setTrainings(datos.data);
      }
    };

     useEffect(() => {
        getCertificate();
        getKnowledges();
        getSkillsCode();
        getSkillsDesing();
        getExperiences();
        getTrainings();
      }, []);

  return (
    <section class="content__page content__curriculum">
      {/* <!-- contenido de about me --> */}
      <header class="curriculum__header">
        <h1 class="curriculum__title">Curriculum</h1>
      </header>
      <div class="curriculum__container">
        <div class="curriculum__left">
          <header class="curriculum__subheader">
            <h2 class="curriculum__subtitle">Formacion</h2>
          </header>
          <div class="curriculum__timelines">
          {trainings.map((training) => {
            return(
            <article class="timelines__timeline">
              <header class="timiline__header">
                <h4 class="timeline__year"> {training.year} </h4>
                <span class="timeline__company"> {training.company} </span>
              </header>
              <div class="timeline__divider"></div>
              <div class="timeline__description">
                <h3 class="timeline__title">{ training.title} </h3>
                <p class="timeline__text"> {training.description} </p>
              </div>
            </article>
            );
          })}
            

          </div>
          <header class="curriculum__subheader">
            <h2 class="curriculum__subtitle">Experiencias</h2>
          </header>
          <div class="curriculum__timeline">
            {experiences.map((experience) => {
              return(
            <article class="timelines__timeline">
              <header class="timiline__header">
                <h4 class="timeline__year"> {experience.year} </h4>
                <span class="timeline__company"> {experience.company} </span>
              </header>
              <div class="timeline__divider"></div>
              <div class="timeline__description">
                <h3 class="timeline__title"> {experience.title} </h3>
                <p class="timeline__text"> {experience.description} </p>
              </div>
            </article>
              );
            })}
            

          </div>
        </div>
        <div class="curriculum__right">
           <header class="curriculum__subheader">
            <h2 class="curriculum__subtitle">
              Stack  <span class="subtitle__color">Tecnológico</span>
            </h2>
          </header>

          {/* <div class="tags-container">
              <span class="tag tag-tech">Python</span>
              <span class="tag tag-tech">Django</span>
              <span class="tag tag-tech">ReactJS</span>
              <span class="tag tag-tech">Wazuh SIEM</span>
              <span class="tag tag-tech">Linux/Bash</span>
              <span class="tag tag-tech">MySQL</span>
          </div> */}

           <div class="tags-container">
            {skillsCode.map((skillcode) => {
              return (             
                <span class="tag tag-tech">{skillcode.title}</span>             
              );
            } )}
            </div>
            
          <header class="curriculum__subheader">
            <h2 class="curriculum__subtitle">
              Herramientas<span class="subtitle__color"> Multimedia</span>
            </h2>
          </header>

              <div class="tags-container">
            {skillsDesing.map((skilldiseng) => {
              return (             
                <span class="tag tag-tech">{skilldiseng.title}</span>             
              );
            } )}
            </div>

          {/* {skillsDesing.map((skilldiseng) => {
            return(
          <div class="curriculum__skills">
            <article class="skills__title">
              <h4 class="skills__text"> {skilldiseng.title} </h4>
              <span class="skills__number"> {skilldiseng.percentage} %</span>
            </article>
            <div class="skills__progressbar">
              <div class="skills__porcentage"></div>
            </div>
          </div>
            );
          } )} */}
          

         
         

          <header class="curriculum__subheader">
            <h2 class="curriculum__subtitle">Area de conocimiento</h2>
          </header>

          <div class="curriculum__knowledges">
              <ul class="knowledges__list">
          { knowledges.map((knowledge) => {
            return(
            
                <li class="knowledges__options"> {knowledge.title} </li>
              
            );
           })}
          </ul>
            </div>

        </div>
      </div>
      <div class="curriculum__certificates">
        <header class="curriculum__subheader">
          <h2 class="curriculum__subtitle">Certificados</h2>
        </header>

        <section class="certificates__container">
          {certifitaces.map((certificate) => {

            return(
               <article class="certificates__certificate">
                  <div class="certificate__logo">
                    <img
                      src= { Global.media + certificate.logo}
                      alt="Certificado"
                      class="certificate__image"
                    />
                  </div>
                  <div class="certificate__content">
                    <h4 class="certificate__title"> {certificate.title} </h4>
                    <span class="certificate__id">
                      ID Verificacion: {certificate.verificate}
                    </span>
                    <span class="certificate__date"> {certificate.data_certi} </span>
                  </div>
                </article>
            );
          })}
         

        </section>
      </div>
    </section>
  );
};
